import { el } from "@dhx/ts-common/dom";

export function getIconGroup(
	handler: any,
	id: string,
	icons: any[],
	selectedId?: string,
	checkboxMode?: boolean
) {
	return el(
		".icons_group",
		{
			onclick: [handler, id],
		},
		icons.map(icon =>
			el(
				"div",
				{
					class: (icon.css || "") + ` ${icon.id === selectedId ? "dhx_selected" : ""}`,
					dhx_id: checkboxMode && selectedId === icon.id ? "" : icon.id,
				},
				[icon.el || null]
			)
		)
	);
}

export function getSelect(handler: any, id: string, opt: any[], selectedId: string) {
	let selected = opt[0];
	const options = opt.map(option => {
		if (option.disabled) {
			return;
		}
		let css;
		if (option.id === selectedId) {
			selected = option;
			css = "dhx_selected_option";
		}
		return el(
			".dhx_select_option",
			{
				onmousedown: [handler, id, option.id],
				tabIndex: 1,
				class: css,
			},
			[
				option.el ? option.el() : el("div", { class: option.class || "" }, option.text || ""),
				option.id === selectedId && el(".dxi.dxi-check"),
			]
		);
	});
	return [
		el(
			".dhx_custom_select",
			{
				tabIndex: 1,
			},
			[
				el(".dhx_select_label", [
					selected.el
						? selected.el()
						: el("div", { class: selected.class || "" }, selected.text || ""),
				]),
				el(".dhx_select_content", options),
			]
		),
	];
}
